export default "__VITE_ASSET__DCB_GNHI__"